import React from 'react';
import {Typography} from '@mui/material';
import ApprovalBox from './approval-box';
import { GET_ACCEPTED_GENERAL_TERMS_AND_PRIVACY } from "queries/queries";
import { ACCEPT_GENERAL_TERMS, ACCEPT_PRIVACY } from 'queries/mutations';
import { useQuery, useMutation } from "@apollo/client";

const Approvals = () => {
  const { data, refetch } = useQuery(GET_ACCEPTED_GENERAL_TERMS_AND_PRIVACY, {
    fetchPolicy: "no-cache",
  });
  
  const acceptedGeneralTerms = data?.currentUser?.acceptedGeneralTerms;
  const acceptedPrivacy = data?.currentUser?.acceptedPrivacy;

  const [acceptGeneralTerms] = useMutation(ACCEPT_GENERAL_TERMS, {
    onCompleted: () => {
      refetch();
    },
    onError: (error) => {
      console.error("[Error] General Terms Mutation:", error);
    },
  });
  
  const [acceptPrivacy] = useMutation(ACCEPT_PRIVACY, {
    onCompleted: () => {
      refetch();
    },
    onError: (error) => {
      console.error("[Error] Privacy Mutation:", error);
    },
  });
  
  const handleGeneralTermsAccept = (accepted) => {
    acceptGeneralTerms({ variables: { accepted } });
  };

  const handlePrivacyAccept = (accepted) => {
    acceptPrivacy({ variables: { accepted } });
  };

  return (
    <div className="profile-approval-container" style={{marginBottom: 70}}>
      <Typography gutterBottom variant="h6" className="profile-approval-title">
        Freigaben
      </Typography>
      <ApprovalBox 
        text="Teilnahmebedingungen" 
        link="/#/rules" 
        accepted={acceptedGeneralTerms} 
        onAccept={handleGeneralTermsAccept} 
      />
      <ApprovalBox 
        text="Datenschutzhinweise" 
        link="/#/data-protection" 
        accepted={acceptedPrivacy}
        onAccept={handlePrivacyAccept}
      />
      <ApprovalBox text="FAQ" link="/#/faq" accepted={false} onAccept={() => {}} />
    </div>
  );
};

export default Approvals;
